'use strict';

var eventFns = ['on', 'off', 'once'];
var isFunction = function isFunction(fn) {
    return typeof fn === 'function';
};

var initCommonFns = function initCommonFns(sdk) {
    eventFns.forEach(function (name) {
        sdk[name] = function (key, fn, context) {
            var process = function process() {
                if (sdk[sdk.env][name]) {
                    return sdk[sdk.env][name](key, fn, context);
                }
            };
            return sdk.isReady ? process() : sdk.ready(process);
        };
    });
};

var initHyFns = function initHyFns(sdk, events, debug) {
    eventFns.forEach(function (name) {
        sdk.hy[name] = function (key, fn, context) {
            if (events[key] && events[key].hy) {
                var eventName = events[key].hy.key || key,
                    process = function process() {
                    if (sdk.env === 'hy') {
                        debug && console.info('[HySDK] Hy bind event\uFF0Cname: ' + eventName);
                        var bridgeFns = name === 'off' ? sdk.bridge[name](eventName, context) : sdk.bridge[name](eventName, fn, context);
                        return bridgeFns;
                    }
                };
                return sdk.isReady ? process() : sdk.ready(process);
            }
        };
    });
};

var initWechatFns = function initWechatFns(sdk) {
    eventFns.forEach(function (name) {
        // Wechat 现在并没有事件逻辑，预留接口
        sdk.wechat[name] = function () {};
    });
};

var initH5Fns = function initH5Fns(sdk) {
    eventFns.forEach(function (name) {
        // H5 暂不提供事件逻辑，预留接口
        sdk.h5[name] = function () {};
    });
};

var initNameSpaceFns = function initNameSpaceFns(sdk, name, conf) {
    var namespace = conf.namespace,
        bridge = conf.bridge;

    eventFns.forEach(function (e) {
        sdk[namespace][e] = function (key, fn, context) {
            if (name && bridge) {
                var eventName = bridge,
                    process = function process() {
                    if (sdk.env === 'hy') {
                        var bridgeFns = e === 'off' ? sdk.bridge[e](eventName, context) : sdk.bridge[e](eventName, fn, context);
                        return bridgeFns;
                    }
                };
                return sdk.isReady ? process() : sdk.ready(process);
            }
        };
    });
};

var initEventFns = function initEventFns(sdk, key, env) {
    var name = key.replace(/\w/, function (a) {
        return a.toUpperCase();
    }),
        obj = env ? sdk[env] : sdk;
    eventFns.forEach(function (eventFn) {
        obj[eventFn + name] = function () {
            var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var context = arguments[1];

            var callback = opt.success || opt;
            if (isFunction(callback)) {
                obj[eventFn](key, callback, context);
            } else if (eventFn === 'off') {
                obj[eventFn](key, context);
            }
        };
    });
};

module.exports = {
    initCommonFns: initCommonFns,
    initHyFns: initHyFns,
    initWechatFns: initWechatFns,
    initH5Fns: initH5Fns,
    initNameSpaceFns: initNameSpaceFns,
    initEventFns: initEventFns
};


//////////////////
// WEBPACK FOOTER
// ../src/bind.js
// module id = 28
// module chunks = 0 2 4